import { doc, type Firestore, type Transaction } from 'firebase/firestore';
import type { TripConfig } from '../types';
import { changeDestinationItem, destinationDates, type DestinationItem, type SharedItemField } from './destinationItems';

/** Reads are separate so callers can compose item, expense and import-receipt writes atomically. */
export async function readDestinationDocs(transaction: Transaction, db: Firestore, tripId: string, dates: string[]) {
  return Promise.all([...new Set(dates)].map(async date => {
    const ref = doc(db, 'trips', tripId, 'itinerary', date);
    const snapshot = await transaction.get(ref);
    return { date, ref, data: snapshot.data() ?? {} };
  }));
}

export async function writeDestinationItem(transaction: Transaction, db: Firestore,
  tripId: string, date: string, field: SharedItemField, id: string, patch: Record<string, unknown> | null) {
  const trip = await transaction.get(doc(db, 'trips', tripId));
  if (!trip.exists()) throw new Error('This trip is no longer available.');
  const days = await readDestinationDocs(transaction, db, tripId, destinationDates(trip.data() as TripConfig, date));
  // Use the selected day's item to seed metadata on missing legacy sibling copies.
  const original = days.find(day => day.date === date)?.data[field]?.find((item: DestinationItem) => item.id === id);
  if (patch && !original && !('name' in patch)) throw new Error('This item has changed. Reopen the Shortlist and try again.');
  const change = patch === null ? null : { ...original, ...patch };
  for (const day of days) {
    transaction.set(day.ref, { [field]: changeDestinationItem(day.data[field] ?? [], id, change) }, { merge: true });
  }
}
